const apiVersion = 'v1'

export const BASE_PATH = `api/${apiVersion}/clients/58/accounting-entry/`
